<template>
  <v-row>
    <v-col cols="12" sm="12" lg="3" md="3">
      <CardSummary :summary="summaries.activating"></CardSummary>
    </v-col>
    <v-col cols="12" sm="12" lg="3" md="3">
      <CardSummary :summary="summaries.pairing"></CardSummary>
    </v-col>
    <v-col cols="12" sm="12" lg="3" md="3">
      <CardSummary :summary="summaries.cocreating"></CardSummary>
    </v-col>
    <v-col cols="12" sm="12" lg="3" md="3">
      <CardSummary :summary="summaries.complete"></CardSummary>
    </v-col>
  </v-row>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import timelineConfig from './config'
import postAPI from '../../Post/postApi';
import CardSummary from './CardSummary'
export default {
  name: 'TimelineSummaryBoxes',
  components: {
    CardSummary
  },
  props: [
    'campaignID',
    'refresh'
  ],
  data() {
    return {
      summaries: timelineConfig.defaultSummaries
    }
  },
  computed: {
    ...mapState({
      campaignDetail: state => state.campaign.campaignDetail,
      reports: state => state.campaign.reports,
      detail: state => state.campaignTimeline.timelineDetail,
      reviewMeetingDetail: state => state.campaignTimeline.reviewMeetingDetail,
      savedTimeline: state => state.campaignTimeline.savedTimeline
    }),
    ...mapGetters('campaignTimeline', [
      'getActivatingDays',
      'getProjectedDaysByStage',
      'getPairingDays',
      'getCocreatingDays',
      'getCompleteDays'
    ])
  },
  watch: {
    refresh(value) {
      if (value) this.getSummaryMain()
    }
  },
  async mounted() {
  },
  methods: {
    async getSummaryMain() {
      await this.$store.dispatch('campaign/getCampaignDetail', this.campaignID)
      await this.$store.dispatch('campaignTimeline/getCampaignTimeline', this.campaignID)
      await this.$store.dispatch('campaignTimeline/getReviewMeeting', this.campaignID)
      await this.$store.dispatch('campaign/getReportsByCampaignIDs', [this.campaignID])
      this.setActivating()
      this.setPairing()
      this.setCocreating()
      this.setComplete()
    },
    setActivating() {
      let activatingDays = this.getActivatingDays(this.campaignDetail)
      let projectedDays = this.getProjectedDaysByStage(timelineConfig.timelineTypes.ACTIVATING)
      let activatingDaysDisplay = {
        briefingDays: activatingDays.briefing.days,
        briefingStartDate: activatingDays.briefing.startDate,
        briefingEndDate: activatingDays.briefing.endDate
      }
      this.summaries.activating.projected = projectedDays ? `${projectedDays} days` : 'invalid'
      this.summaries.activating.actual = activatingDaysDisplay.briefingDays ? `${activatingDaysDisplay.briefingDays} days` : 'invalid'
      this.summaries.activating.actualTasks[0].value = activatingDaysDisplay.briefingStartDate ? `${activatingDaysDisplay.briefingStartDate}` : 'invalid'
      this.summaries.activating.actualTasks[1].value = activatingDaysDisplay.briefingEndDate ? `${activatingDaysDisplay.briefingEndDate}` : 'invalid'
    },
    setPairing() {
      /* eslint-disable */
      let pairingDays = this.getPairingDays(this.campaignDetail)
      let projectedDays = this.getProjectedDaysByStage(timelineConfig.timelineTypes.LINEUP)
      let actualDays = 0
      if (pairingDays.firstPayoutConfirmed.days) actualDays += parseInt(pairingDays.firstPayoutConfirmed.days)
      if (pairingDays.allPayoutConfirmed.days) actualDays += parseInt(pairingDays.allPayoutConfirmed.days)
      this.summaries.pairing.projected = projectedDays ? `${projectedDays} days` : 'invalid'
      this.summaries.pairing.actual = actualDays ? `${actualDays} days` : 'invalid'
      let idx = 0
      let pairingDaysDisplay = {
        firstPayoutConfirmedStartDate: pairingDays.firstPayoutConfirmed.startDate, // brief accepted at
        allPayoutConfirmedStartDate: pairingDays.allPayoutConfirmed.startDate, // first payout confirmed date
        allPayoutConfirmedEndDate: pairingDays.allPayoutConfirmed.endDate, // all payout confirmed date
      }
      for (const [key, value] of Object.entries(pairingDaysDisplay)) {
        this.summaries.pairing.actualTasks[idx].value = value || value === 0 ? `${value}` : 'invalid'
        idx += 1
      }
      // console.log(pairingDays)
    },
    async setCocreating() {
      /* eslint-disable */
      let projectedDays = this.getProjectedDaysByStage(timelineConfig.timelineTypes.COCREATING)
      const postResp = await postAPI.getPost({campaignId: this.campaignID, status: -1})
      let cocreatingDays = await this.getCocreatingDays(postResp.posts || [], this.reports)
      let actualDays = 0
      if (cocreatingDays.firstContentSubmitted.days) actualDays += parseInt(cocreatingDays.firstContentSubmitted.days)
      if (cocreatingDays.firstReportLive.days) actualDays += parseInt(cocreatingDays.firstReportLive.days)
      if (cocreatingDays.lastReportLive.days) actualDays += parseInt(cocreatingDays.lastReportLive.days)
      this.summaries.cocreating.projected = projectedDays ? `${projectedDays} days` : 'invalid'
      this.summaries.cocreating.actual = actualDays ? `${actualDays} days` : 'invalid'
      let idx = 0
      let cocreatingDaysDisplay = {
        // executing days
        firstContentSubmittedStartDate: cocreatingDays.firstContentSubmitted.startDate,
        // submitting days
        firstReportLiveStartDate: cocreatingDays.firstReportLive.startDate,
        // live days
        lastReportLiveStartDate: cocreatingDays.lastReportLive.startDate,
        lastReportLiveEndDate: cocreatingDays.lastReportLive.endDate,
      }
      for (const [key, value] of Object.entries(cocreatingDaysDisplay)) {
        this.summaries.cocreating.actualTasks[idx].value = value || value === 0 ? `${value}` : 'invalid'
        idx += 1
      }
    },
    async setComplete() {
      /* eslint-disable */
      let projectedDays = this.getProjectedDaysByStage(timelineConfig.timelineTypes.COMPLETE)
      let completeDays = await this.getCompleteDays(this.reports)
      let actualDays = 0
      if (completeDays.reviewDate.days) actualDays += parseInt(completeDays.reviewDate.days)
      this.summaries.complete.projected = projectedDays || projectedDays === 0 ? `${projectedDays} days` : 'invalid'
      this.summaries.complete.actual = actualDays ? `${actualDays} days` : 'invalid'
      let idx = 0
      let completeDaysDisplay = {
        // executing days
        reviewDateStartDate: completeDays.reviewDate.startDate,
        reviewDateEndDate: completeDays.reviewDate.endDate
      }
      for (const [key, value] of Object.entries(completeDaysDisplay)) {
        this.summaries.complete.actualTasks[idx].value = value || value === 0 ? `${value}` : 'invalid'
        idx += 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SummaryBoxes.vue?5b8bb776